import React from 'react';

function Skills(props){
    return(
        <div className='text-center m-5' id='skillid'>
            <h2>My Tech Skills</h2>
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/CSS3_and_HTML5_logos_and_wordmarks.svg/791px-CSS3_and_HTML5_logos_and_wordmarks.svg.png?20150111171555" height="150" />
       

        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Sql_data_base_with_logo.png/800px-Sql_data_base_with_logo.png?20210130181641" height="60" />
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Mongodb.png/800px-Mongodb.png?20180423182709" height="100" />
        <img src="https://cdn.pixabay.com/photo/2015/04/23/17/41/node-js-736399_960_720.png" height="100" />
        <img src="https://cdn.pixabay.com/photo/2015/04/23/17/41/javascript-736400_960_720.png"  height="120" />
        <img src="https://logos-download.com/wp-content/uploads/2016/10/Java_logo_icon-700x392.png"  height="120" />
        <br/>
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/React.svg/768px-React.svg.png?20171020144116"  height="140" />
            </div> 
    )
}

export default Skills